import { render, staticRenderFns } from "./information.edit.vue?vue&type=template&id=fcb9d2d8&scoped=true"
import script from "./information.edit.vue?vue&type=script&lang=js"
export * from "./information.edit.vue?vue&type=script&lang=js"
import style0 from "./information.edit.vue?vue&type=style&index=0&id=fcb9d2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb9d2d8",
  null
  
)

export default component.exports